import script from "./AdvComp.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdvComp.vue?vue&type=script&lang=ts&setup=true"

import "./AdvComp.vue?vue&type=style&index=0&id=b1418238&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1418238"]])

export default __exports__